import { iosChrome, iosFirefox, iosSafari, macSafari } from "./browserDetect";
import { logDetailed } from "./utils";

// A top to bottom rewrite of the filesaver.js library
// simplifies cases where the "blob" provided is actually a url
// hopefully resolves some browser detection holes

const modernizr = window.Modernizr;
const canUseMSBlob = "msSaveOrOpenBlob" in navigator;

export const canSaveBlobs = (function(){
  if (!modernizr.blobconstructor) return false;
  if (iosFirefox) return false;
  if (!(canUseMSBlob || modernizr.bloburls || (modernizr.filereader && modernizr.datauri))) return false;
  return true;
})();

export function saveBlob (blob, name) {
  if (!(blob instanceof Blob)) return console.error("Cannot download non-blobs");
  name = name || blob.name || "download";
  let openCB = getOpenCB();
  let loadCB = getLoadCB(blob);
  return openCB(blob, name, loadCB);
}

function getOpenCB(){
  if (canUseMSBlob) return load_msSaveBlob;
  return modernizr.adownload ? open_anchor : open_popup;
}

function getLoadCB(blob){
  if (canUseMSBlob) return null;

  if (!shouldUseFileReader(blob) && modernizr.bloburls) return load_blobUrl;
  
  return canUseFileReader(blob) ? load_fileReader : null;
}

function shouldUseFileReader(blob) {
  return iosChrome
    || (iosSafari && isImage(blob))
    || (macSafari && isOctetStream(blob));
}

function canUseFileReader(blob) {
  return modernizr.filereader
    && modernizr.datauri
    && (blob.size < 32000000 || modernizr.datauri.over32kb);
}

function isImage(blob){
  return (blob.type || "").toLowerCase().includes("image");
}

function isOctetStream(blob){
  return (blob.type || "").toLowerCase() === "application/octet-stream";
}

function load_msSaveBlob(blob, name) {
  logDetailed("blobsaver", "load_msSaveBlob", "saving blob via ms save or open blob");
  navigator.msSaveOrOpenBlob(blob, name);
}

function open_anchor(blob, name, loadCB) {
  logDetailed("blobsaver", "open_anchor", "saving blob via anchor tag");
  if (loadCB === null) throw "cannot download blob";
  var a = document.createElement("a");
  a.download = name;
  a.rel = "noopener"; // tabnabbing
  var cb = url => openUrlWithAnchor(url, a);
  loadCB(blob, cb);
}

function open_popup(blob, loadCB) {
  logDetailed("blobsaver", "open_popup", "saving blob via popup window");
  if (loadCB === null) throw "cannot download blob";
  var popup = window.open("", "_blank");
  if (popup) {
    popup.document.title =
      popup.document.body.innerText = "downloading...";
  }
  var cb = url => openUrlWithPopup(url, popup);
  loadCB(blob, cb);
}

function load_blobUrl(blob, cb) {
  logDetailed("blobsaver", "load_blobUrl", "loading blob via blob url");
  var url = URL.createObjectURL(blob);
  cb(url);
  setTimeout(function () { URL.revokeObjectURL(url); }, 4E4); // 40s
}

function load_fileReader(blob, cb) {
  logDetailed("blobsaver", "load_fileReader", "loading blob via file reader");
  var reader = new FileReader();
  reader.onloadend = function () {
    var url = reader.result;
    url = iosChrome ? url : url.replace(/^data:[^;]*;/, "data:attachment/file;");
    cb(url);
  };
  reader.readAsDataURL(blob);
}

function openUrlWithAnchor(url, a) {
  a.href = url;
  setTimeout(function () { click(a); }, 0);
}

function openUrlWithPopup(url, popup) {
  if (popup) popup.location.href = url;
  else window.location.href = url;
  popup = null; // reverse-tabnabbing #460
}

// `a.click()` doesn't work for all browsers (#465)
function click(node) {
  try {
    node.dispatchEvent(new MouseEvent("click"));
  } catch (e) {
    var evt = document.createEvent("MouseEvents");
    evt.initMouseEvent("click", true, true, window, 0, 0, 0, 80,
      20, false, false, false, false, 0, null);
    node.dispatchEvent(evt);
  }
}